

import './formRadio.css'

function FormRadio({data, itemChoisir, setItemChoisir, name}) {
    return (
        <div className='form-radio'>
            {
                data.map((item, index) => (
                    <div key={index}>
                        <input type="radio" name={name} id={`${item.nom}`} checked={item.id === itemChoisir.id} onChange={() => setItemChoisir(item)} />
                        <label htmlFor={`${item.nom}`}>{item.nom}</label>
                    </div>
                ))
            }
        </div>
    )
}

export default FormRadio
